<div *transloco="let t;" class="h-full relative flex ">
    <div class="absolute w-full h-full">
        <img class="w-full h-full opacity-60 object-cover -scale-x-100" src="/assets/img/Home/BG-Homepage-Header.jpg" />
    </div>
    <div class="absolute top-0 left-0">
        <img class="w-32" src="./assets/img/Home/Label-Beta.png" />
    </div>
    <!-- flex-col md:flex-row -->
    <div class="w-full h-full flex flex-wrap pt-20 pb-4 items-center sm:pt-6 z-10 overflow-y-auto">
        <div class="w-full md:w-1/2  items-center justify-center flex">
            <!-- <div class="auth-text"> -->
            <h1 class="font-bold text-7xl md:text-8xl font-nikkyou">
                <span>{{t('signIn.welcomeTo')|uppercase}}</span>
                <br>
                <span>{{t('signIn.theKmon')|uppercase}}</span>
                <br>
                <span class="gradient-green_yellow">{{t('signIn.trainerHub')|uppercase}}</span>
            </h1>

            <!-- </div> -->
        </div>

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <div class="w-full md:w-1/2 justify-center md:justify-end md:pr-13 flex">
            <router-outlet *ngIf="true"></router-outlet>
        </div>

    </div>
    <language-switch class="fixed z-20" style="bottom: 10.5rem;"></language-switch>
</div>